import { Injectable } from "@angular/core";
import { StateService } from "@core-services/state.service";
import { Observable } from "rxjs";

export interface AppropriatenessState {
	status: string;
}

@Injectable({
	providedIn: "root"
})
export class AppropriatenessStateService extends StateService<AppropriatenessState> {
	public constructor() {
		super(null);
	}

	public getState$(): Observable<AppropriatenessState> {
		return this.select((state) => state);
	}

	public updateState(model: AppropriatenessState): void {
		this.setState(model);
	}

	public stateLoaded(): boolean {
		return this.isStateLoaded();
	}
}
